import React from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { FormProvider, useForm } from "react-hook-form";
import {
  PaziaButton,
  PaziaFormButton,
  PaziaInput,
  PaziaTextarea,
} from "components/atoms";
import { CourseTermsApi } from "api/courseTermsApi";

export const UpdateTermsForm = ({
  terms,
  onSubmit,
  onCancel,
}: {
  terms: CourseTermsApi;
  onSubmit: (values: UpdateTermsFormValues) => Promise<void>;
  onCancel: () => void;
}) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      [FORM_NAMES.ID]: terms.id,
      [FORM_NAMES.NAME]: terms.name,
      [FORM_NAMES.DESCRIPTION]: terms.description,
    },
  });

  const { handleSubmit, reset } = methods;

  const onSubmitHandler = async (values: UpdateTermsFormValues) => {
    await onSubmit(values);
    reset();
  };
  return (
    <FormProvider {...methods}>
      <form className="flex flex-col gap-2" onSubmit={handleSubmit(onSubmitHandler)}>
        <PaziaInput required label="Nazwa" name={FORM_NAMES.NAME} />
        <PaziaTextarea label="Opis" name={FORM_NAMES.DESCRIPTION} />
        <div className="ml-auto flex gap-2">
          <PaziaButton title="Anuluj" type="tertiary" btnType="button" onClick={onCancel} />
          <PaziaFormButton type="success">Zapisz</PaziaFormButton>
        </div>
      </form>
    </FormProvider>
  );
};

const FORM_NAMES = {
  ID: "id",
  NAME: "name",
  DESCRIPTION: "description",
} as const;

const schema = yup
  .object({
    [FORM_NAMES.ID]: yup.number().required(),
    [FORM_NAMES.NAME]: yup.string().required(),
    [FORM_NAMES.DESCRIPTION]: yup.string().nullable(),
  })
  .required();

export type UpdateTermsFormValues = yup.InferType<typeof schema>;
